import { http } from '@frontend/fetch';
import { CategorizedDraftError, DraftErrorCategory } from './draft.types';

export const isBrowserOnline = () => (typeof navigator === 'undefined' ? true : navigator.onLine !== false);

const categoryByStatus = (status: number): DraftErrorCategory => {
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 404 || status === 410) return 'not-found';
  if (status === 429) return 'throttled';
  if (status === 408 || status >= 500) return 'transient';
  if (status >= 400) return 'invalid';
  return 'transient';
};

/** Maps a draft request failure into a typed outcome. Network failures while offline are `offline`, not `transient`. */
export const categorizeDraftError = (error: unknown, isOnline: boolean = isBrowserOnline()): CategorizedDraftError => {
  if (!isOnline) return { category: 'offline' };

  if (http.isHttpError(error)) {
    const status = error.status ?? 0;
    return { category: categoryByStatus(status), status };
  }

  return { category: 'transient' };
};

/** Categories that may be retried automatically within the retry budget. */
export const isRetryableDraftError = (category: DraftErrorCategory) =>
  category === 'transient' || category === 'throttled';
